module.exports = __webpack_public_path__ + "img/chart3.670ca975.png";